export const env = 'dev'
export const firebaseConfig = {"apiKey":"AIzaSyAECvQGtSbTa6P0o69l-fGgrMp2xLAeKlY","appId":"1:824103114815:web:920ecf835920e36ead808a","authDomain":"stg.guidde.com","databaseURL":"https://guidde-dev-staging-default-rtdb.firebaseio.com","measurementId":"","messagingSenderId":"824103114815","projectId":"guidde-dev-staging","storageBucket":"guidde-dev-staging.appspot.com","environment":"staging"}

export const stripeKey =
'pk_test_51JyZ87K0Rqte2wN0gFebhmPWtXtXa9Cwc7gzzbPJfgkr9Q4o7lltzaA4jdhzwq30BGqSL9bHOAmTteg9oOAR8utl00vx02mNo5'
export const stiggClientKey =
'$2b$10$2tLiBrjgm05excoNtNqQS.PvzVTP.dnsM3fL/Jk77AeedV6moEpIO:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const inScreenTenantId =
'21f3809f-59e2-40b6-885c-79046966b7bd'